// NOT GENERATED
// use this file to manually track the translations we support

export default {
  data: {}, // default is empty
  supported: ['fr-CA', 'fr', 'es', 'es-US', 'en-AU', 'en-GB']
};
